<template>
    <div
        :class="[
            'inline-flex justify-center items-center px-2.5 py-0.5 rounded-lg font-medium whitespace-nowrap',
            ...colorClass, large ? 'text-lg' : '', small ? 'text-sm' : '', dull ? 'opacity-70' : '',
            xSmall ? 'text-xs' : '' ,
        ]"
        :style="minWidthStyle"
    >
        <slot />
    </div>
</template>

<script>
    import advisory_partner_mixin from '@/mixins/advisory_partner_mixin';

    export default {
        mixins: [
            advisory_partner_mixin,
        ],
        props: {
            color: {
                required: true,
                type: String,
            },
            dark: {
                default: false,
                type: Boolean,
            },
            dull: {
                default: false,
                type: Boolean,
            },
            large: {
                default: false,
                type: Boolean,
            },
            small: {
                default: false,
                type: Boolean,
            },
            xSmall: {
                default: false,
                type: Boolean,
            },
            minWidth: {
                default: 0,
                type: Number,
            },
        },
        computed: {
            colorClass() {
                switch (this.color) {
                    case 'white':
                        return ['bg-white text-${this.colorScheme}-800'];
                    default:
                        return [
                            this.dark ? `bg-${this.color}-200` : `bg-${this.color}-100`,
                            `text-${this.color}-800`,
                        ];
                }
            },
            minWidthStyle() {
                return this.minWidth ? { minWidth: `${this.minWidth}px` } : {};
            },
        },
    };
</script>
